import React from 'react';
import { withRouter } from 'react-router-dom';
import { Loading } from './../../../../components/includes/loading';
import BuilderSelector from './../selector';
import BuilderSelectionOptions from './../options/options';
import BuilderSelectionText from './../options/text';

import { PollService } from './../../../../services';

class BuilderConfig extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      id: null,
      pollId: null,
      selected: null
    };
  }

  componentDidMount(){

    this.handleInit();

  }

  /*
  ** @Event
  ** @Description: Init
  */

  handleInit = () => {
    this.setState({
      pollId: this.props.match.params.id,
    });

    if(this.props.id && this.props.type){
      this.setState({
        id: this.props.id,
        selected: {
          type: this.props.type,
          title: 'test',
          subheader: 'subheader test'
        }
      });
    }
  }

  /*
  ** @Service
  ** @Description: Save Question
  */

  _Save = (values) => {

    // @Loading
    this.setState({ loading: true });

    let toSend = Object.assign(values, {
      id: this.state.pollId,
      type: this.state.selected.type
    });

    PollService.saveQuestion(toSend).then((response) => {

      // @Success
      this.props.onSuccess();

      // @Loading
      this.setState({ loading: false });


    }).catch((error) => {

      // @Loading
      this.setState({ loading: false });

      // @Dispatch alert error
      //this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Event
  ** @Description: Select option
  */

  handleSelect = (values) => {
    this.setState({
      selected: values
    });
  }

  /*
  ** @Event
  ** @Description: Select option
  */

  handleSubmit = (values) => {
    this._Save(values);
  }

  render() {

    const { loading, selected } = this.state;

    return(

      <React.Fragment>

        {loading && (
          <Loading variant="secondary"/>
        )}

        {!selected && (
          <BuilderSelector onSelect={ this.handleSelect }/>
        )}

        {( selected && (selected.type === 'multiple' || selected.type === 'option' || selected.type === 'valuation') ) && (
          <BuilderSelectionOptions
            selected={ selected }
            onCancel={ () => { this.handleSelect(false) } }
            onSubmit={ this.handleSubmit }
          />
        )}

        {( selected && selected.type === 'text') && (
          <BuilderSelectionText
            selected={ selected }
            onCancel={ () => { this.handleSelect(false) } }
            onSubmit={ this.handleSubmit }
          />
        )}

      </React.Fragment>

    )
  }

}

export default withRouter(BuilderConfig);
